<div mat-dialog-title id="{{title}}">{{title}}
  <div class="dialog-close-button">
    <a (click)="onClose()" id="close">
      <img src="/assets/images/close-popup.png">
    </a>
  </div>
</div>
<form class="example-form" (ngSubmit)="onSubscriptionSubmit(subscriptionForm)" #subscriptionForm="ngForm">
  <div mat-dialog-content cdkFocusInitial>
    <p  *ngIf="msg=== 'Subscribe & Save'" class="cartText">Please complete the fields to schedule your {{' ' + title + ' '}} shipment</p>
    <p  *ngIf="msg=== 'Change Subscription'" class='shippingMsg' id="shipping-soon">The changes applied will be effective after {{confirmNextDate | date:'longDate'}}.<br></p>
    <p  *ngIf="msg=== 'Change Subscription'"><b>Change your schedule for:</b></p>
  <div>
    <div class=quantity>
      <div *ngIf="msg=== 'Subscribe & Save'">
      <mat-form-field class="example-full-width">
        <mat-spinner *ngIf="detailsLoading" diameter="30" class="order-loading-spinner"></mat-spinner>
        <mat-label *ngIf="msg=== 'Subscribe & Save'">Start Date</mat-label>
        <input  matInput [min]="minStartDate" [matDatepicker]="picker" id="date" required name="date" #date="ngModel" [(ngModel)]="startDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="date.errors?.required && subscriptionForm.submitted">Required Field</mat-error>
        
      </mat-form-field>
      </div>
      <div *ngIf="msg=== 'Change Subscription'">
        <mat-form-field class="example-full-width">
          <mat-spinner *ngIf="detailsLoading" diameter="30" class="order-loading-spinner"></mat-spinner>
          <mat-label *ngIf="msg=== 'Change Subscription'">{{nextDate}}</mat-label>
          <input  matInput [min]="minNextDate" [matDatepicker]="picker" id="nextdate" required name="nextdate" #nextdate="ngModel" [(ngModel)]="nextDate" [disabled]="!isUpdatable">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="nextdate.errors?.required && subscriptionForm.submitted">Required Field</mat-error>
        </mat-form-field>
      </div>
      <div *ngIf="websiteName == 'Major'">
        <div *ngIf="termType== 'BOTH' || termType== 'PAYONTERMS'">
          <mat-radio-button class="payOptions" id="payOnTerms" type="radio" value="payOnTerms" [checked]="selectedPayOnTerms"
            (click)="onPayOnTermSelect($event)">Pay On Terms</mat-radio-button><br>
        </div>
        <div *ngIf="termType== 'BOTH' || termType== 'CREDITCARD'">
          <mat-radio-button class="payOptions" id="creditCards" type="radio" value="creditCards"
            [checked]="selectedCreditCardPayment" (click)="onCreditCardButtonSelect()">Credit Cards</mat-radio-button>
        </div>
        <div class="addcardMsg" *ngIf="payOptionChosen==false">
          Please select a payment option for subscription.
        </div>
        <div *ngIf="creditCardFlag==true">
          <label>Select Credit Card : </label>
          <select class="credit-card-drop-down" placeholder="Strength" name="creditCard" [(ngModel)]="selectedCreditCard" id="credit-card">
            <option disabled>Please select a credit card
            </option>
            <option *ngFor="let card of creditCards; let i = index" id="credit-card1-{{i}}" [ngValue]="card">{{card.cardType
              +" card ending "+ card.lastFourdigit}}</option>
          </select>
        </div>
        <div class="addcardMsg" *ngIf="addCreditCardMsg==true && selectedOption=='CREDITCARD'">
          There are currently no credit cards linked to <br>this account. Please visit our <a (click)="goToMangeCreditPage()">Manage Credit Card page</a>
          <br>to add or update payment information.
        </div>
        <div class="addcardMsg" *ngIf="(termType== 'BOTH' || termType== 'CREDITCARD') && selectOneCard==false && selectedOption=='CREDITCARD'">
          Please select a credit card.
        </div>
      </div>
      </div>
      <div class=delivery><label>Delivery Every </label>
        <select class="delivery-list-drop-down" *ngIf="msg=== 'Subscribe & Save'" name="selectedFrequency" [(ngModel)]="selectedFrequency"
          id="delivery-every">
          <option *ngFor="let frequency of subscriptionFrequency; let i = index" id="delivery-every-{{i}}"
            [ngValue]="frequency.typeCode">{{frequency.typeDesc}}</option>
        </select>
        <select class="delivery-list-drop-down" *ngIf="msg=== 'Change Subscription'" name="selectedFrequency" [(ngModel)]="initialFrequency"
          id="delivery-every">
          <option *ngFor="let frequency of subscriptionFrequency; let i = index" id="delivery-every-{{i}}"
            [ngValue]="frequency.typeCode" [disabled]='!isUpdatable'>{{frequency.typeDesc}}</option>
        </select></div>
    </div>
    
    <div class="order-selection-table-responsive table result-container">
      <mat-table #table [dataSource]="subscribeDatasource">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let order; let i = index">

          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef id= "description"> Description </th>
          <td mat-cell *matCellDef="let order;let i= index;" id="description-{{i+1}}"> {{order.description}} 
            <span *ngIf="this.websiteName==='Parmed' && order.priceOverRide===true" id="priceOverrideAlert"><br />* Negotiated Price/Discount Exclusion</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="quantity" *ngIf="msg=== 'Subscribe & Save'">
          <th mat-header-cell *matHeaderCellDef id="qty"> Quantity </th>
          <td mat-cell *matCellDef="let order; let i= index;">
            <input type="text" maxlength="{{qtyLength}}" name="Quantity -{{ i+1}}" id="qty-{{i+1}}" 
            [(ngModel)]="order.orderQuantity" class="text"
            (ngModelChange)="onProductQuantityChange(order)"
            (blur)="showCaseQtyAlert  = checkCaseQtyMultiplier(order)"
              parNumberOnly
            />
          </td>
        </ng-container>
        <ng-container matColumnDef="quantity" *ngIf="msg=== 'Change Subscription'">
          <th mat-header-cell *matHeaderCellDef id="qty"> Quantity </th>
          <td mat-cell *matCellDef="let order; let i= index;">
            <input type="text" maxlength="{{qtyLength}}" name="Quantity -{{ i+1}}" id="qty-{{i+1}}" 
            [(ngModel)]="order.orderQuantity" class="text"
            (ngModelChange)="onProductQuantityChange(order)"
            (blur)="showCaseQtyAlert  = checkCaseQtyMultiplier(order)"
            [attr.disabled]="(!order.isAvailable)||(!isUpdatable) ? 'disabled' : null"
              parNumberOnly
            />
          </td>
        </ng-container>
        <ng-container matColumnDef="availableQuantity">
          <mat-header-cell *matHeaderCellDef id="lbl-available-qty"> Available Quantity </mat-header-cell>
          <mat-cell id="available-quantity-{{j+1}}" *matCellDef="let order; let j = index" [ngClass]="{'warn': order.showQuantityWarning || order.availableQuantity === '0l' || order.unitPrice == null || order.unitPrice == undefined || order.unitPrice <= 0}">
            {{(order.unitPrice == null || order.unitPrice == undefined || order.unitPrice <= 0 || order.availableQuantity == '0l') ? ( "**" ) : (order.availableQuantity)}}
            <span *ngIf="order.showQuantityWarning">
              <br /> {{order.allocationCase}}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="unitPrice">
          <th mat-header-cell *matHeaderCellDef id="unit-price"> Unit Price </th>
          <td class="alignment" mat-cell *matCellDef="let order;let i= index" [ngClass]="{'warn': order.unitPrice == null || order.unitPrice == undefined || order.unitPrice <= 0}" id="unit-price-{{i+1}}" > {{( order.unitPrice == null || order.unitPrice == undefined || order.unitPrice
            <= 0 ) ? ( "**" ) : (order.unitPrice | currency)}}</td>
        </ng-container>
        <ng-container matColumnDef="totalPrice">
          <th mat-header-cell *matHeaderCellDef id="total-price"> Total Price </th>
          <td class="alignment" mat-cell *matCellDef="let order; let i= index;" [ngClass]="{'warn': order.unitPrice == null || order.unitPrice == undefined || order.totalPrice <= 0}" id="total-price-{{i+1}}"> {{( order.totalPrice ==null || order.totalPrice == undefined || order.totalPrice
            <= 0 ) ? ( "**" ) : (order.totalPrice | currency)}} </td>

        </ng-container>

        <ng-container matColumnDef="actionDelete">
          <th mat-header-cell *matHeaderCellDef id="btn-delete"> Delete </th>
          <td mat-cell *matCellDef="let order;let i= index;">    
            <div mat-dialog-actions>
              <button mat-raised-button type="button" id="btn-delete-{{i+1}}"
                (click)="onDeleteClick(order)" [disabled]="!enableDeleteButton || !isUpdatable">Delete</button>
              </div>
              </td>
          
        </ng-container>
        
        <mat-header-row class="rowHeaderColor" *matHeaderRowDef="orderColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: orderColumns; let i = index" id="{{i+1}}"></mat-row>

      </mat-table>
    </div>
    
    <div class="qty-alert" *ngIf="showQtyAlert"
      [ngStyle]="{'color':'red'}" id="qty-error-msg">
      Please enter the quantity.
    </div>
    <div class="case-alert" *ngIf="caseAlertObject.showCaseAlert"
      [ngStyle]="{'color': showCaseQtyAlert? 'red': 'black'}" id="case-qty">
      {{caseAlertObject.caseAlert}}
    </div>
    <div *ngIf="msg=== 'Change Subscription' && (isUnavailable > 0)">
      <p class="errorMsg" id="error-msg">Due to limited stock, the item(s) is not currently available to be edited :</p>
      <p class="itemsName" id="error-items" >{{unavailableItems}}</p>
    </div>
    <div class="order-details">
      <ul>
        <li *ngIf="totalAmount > 0">
          <label  class="order-details">
            Subtotal:
          </label>
          <span  id="subTotal">
            {{subTotal | currency}}
          </span>
        </li>
        <li *ngIf="totalAmount > 0">
          <label  class="order-details">
            Tax:
          </label>
          <span  id="tax">
            {{tax | currency}}
          </span>
        </li>
        <li *ngIf="totalAmount > 0">
          <label  class="order-details">
            Discount:
          </label>
          <span  id="discount">
            {{discount | currency}}
          </span>
        </li>
        <li>
          <label class="order-details" >
            Total:
          </label>
          <span id="totalAmount" [ngClass]="{'warn': totalAmount <= 0}">
            {{(totalAmount
              <= 0 ) ? ( "**" ) : (totalAmount | currency)}}
          </span>
        </li>
      </ul>
    </div>

    <div class="minOrderMsg" *ngIf="showSubscriptionMinOrderMsg">
      <p>
        Your subscription order is below the $100.00 minimum required to subscribe. If you need a product 
        <br/>
        urgently, please call your Sales Rep or our Customer Service department at 800.727.6331.
      </p>
    </div>
    
    <div class=validationMsg *ngIf="isLowSubscriptionTotal">
      <h3 class="totalAmountMsg" id="shipping-away" *ngIf="totalAmount !=null"> You are {{balanceTotal | currency}} from free shipping! </h3>
      <p class="cartText" id="shipping-fee" *ngIf="totalAmount !=null">For subscription less than {{minSubscriptionValue | currency}}, a shipping and handling fee of
        {{shippingCost | currency}} will be applied.</p>
    </div>
  </div>
  <div mat-dialog-actions *ngIf="msg=== 'Change Subscription'">
    <button mat-raised-button [mat-dialog-close]="false" id="btn-cancel">Cancel</button>
    <button mat-raised-button type="submit" id="btn-update" (click)="onUpdateClick()"
      [disabled]="!(enableUpdateButton)">Update</button>
    <button mat-raised-button type="button" id="btn-apply" 
      (click)="onApplyclick()" [disabled]="(!enableApply || totalAmount <= 0)">Apply
    </button>
  </div>
  <div mat-dialog-actions *ngIf="msg=== 'Subscribe & Save'">
    <button mat-raised-button id="btn-cancel" (click)="onClose()">Cancel</button>
    <button mat-raised-button type="submit" id="btn-update" (click)="onUpdateClick()"
      [disabled]="!(enableUpdateButton)">Update</button>
    <button mat-raised-button type="submit" id="btn-add-item" [mat-dialog-close]="false" (click)="onAddAnotherItem()">Add Another Item</button>
    <button mat-raised-button type="submit" id="btn-confirm-sub" (click)="onConfirmSubscriptionClick()" [disabled]="(!enableConfirmSubcribe)" >Confirm
      Subscription</button>
  </div>
</form>